<template>
	<page>
		<module>
			<view-list ref="view" :work-type="work_type" dynamic-field :field-sort="false" :view-config="auth('b_in_process_product_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="工单创建时间" colspan="2">
							<c-datetime :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
						</m-search-item>
					</m-search>
				</template>
				
				<template #operate>
					<c-button v-if="auth('b_in_process_product_export')" v-lock="lock('b_in_process_product_export')"  prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-config" @click="processConfig()">工序配置</c-button>
					<c-button prepend-icon="tf-config" @click="indeicatorFieldConfig()">指标配置</c-button>
				</template>

				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>

				<!--优先级-->
				<template #priority="{data}">
					<c-state dict="priorityDic" tag :value="data.priority"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				work_type: 68,
				defaultSearchData: {
					start_date: new Date(now.getFullYear(), now.getMonth(), 1).format('yyyy-MM-dd') + ' 00:00',
					end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).format('yyyy-MM-dd') + ' 23:59',
				},
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic', 'auditStateDic','priorityDic']),
			...mapGetters(['freeEdition'])
		},

		methods: {
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			//配置工序
			processConfig(){
				this.globalDialog('processConfig',{
					props: {
						type: 2,
						view_id: this.$refs.view.getViewId()
					}
				}, this.updateTableList);
			},
			
			//指标配置
			indeicatorFieldConfig(){
				this.globalDialog('indeicatorFieldConfig',{
					props: {
						work_type: this.work_type,
						view_id: this.$refs.view.getViewId()
					}
				}, this.updateTableList);
			},

			/****刷新列表****/
			updateTableList() {
				//刷新表头
				this.$refs.view.updateDynamicColumn();
				//刷新表数据
				this.$refs.view.update();
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>